import React, { Fragment } from "react";
import { Row, Col, Alert, Collapse, Icon, message } from "antd";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { listingActions } from "redux/modules/listings";
import Loading from "components/loading";
import Mapping from "components/mapping";
import MappingDetails from "components/mapping-details";
import * as Styled from "./styled";
import { mappingActions } from "redux/modules/mappings";

const Panel = Collapse.Panel;
const customPanelStyle = {
  background: "#f7f7f7",
  border: "1px solid #f7f7f7",
  borderRadius: 4,
  marginBottom: 24,
  overflow: "hidden"
};

const ListingDetails = ({
  listing,
  listingId,
  currentStoreId,
  onDelete,
  onSaveMapping
}) => {
  if (!listing) {
    return <Loading />;
  } else if (!listing) {
    return <Alert message="Listing not found" type="error" />;
  }

  const { images, inventory } = listing;
  const {products} = inventory // Etsy has 1-1 mapping between inventory and products

  return (
    <Styled.Container>
      <Helmet title={listing.title}/>
      <h1>
        <a href={listing.url} title="View on Etsy" target="_blank">
          {listing.title}
        </a>
      </h1>
      <p>
        Here are all the different variations we found for this product. You can
        assign a mapping to each variation which will tell our system which
        images should be printed at what size when an order comes in. You can
        also override these mappings when placing an order if necessary. If you
        have a product that allows your customer to choose which items they want
        from a larger set you can add a mapping that contains all of the
        possible choices and then check the box that says "Multiple choice
        item". When orders for a Multiple choice item come in you will be able
        to delete the files not needed.
      </p>
      <p>
        Please note, if you change your listing details in Etsy it will not be
        updated here. You'll have to update your mappings accordingly.
      </p>
      <Row gutter={24}>
        <Col span={6}>
          <img src={images[0].url_570xN} style={{ width: "100%" }} />
        </Col>
        <Col span={18}>
          <Collapse
            accordion={false}
            bordered={false}
            defaultActiveKey={products.map(i => i.product_id.toString())}
            expandIcon={({ isActive }) => (
              <Icon type="caret-right" rotate={isActive ? 90 : 0} />
            )}
          >
            {products.map((i, idx) => {
              const id = `etsy:${listing.listing_id}:${i.product_id}`;
              const properties = i.property_values.map(prop => (
                <span style={{ marginRight: 10 }} key={prop.property_name}>
                  <strong>{prop.property_name}:</strong>{" "}
                  <span>{prop.values.join(", ")}</span>
                </span>
              ));
              return (
                <Panel
                  header={
                    <Row type="flex">
                      <span style={{ flex: 1 }}>
                        Product/Variation - {idx + 1}{" "}
                        {properties.length ? (
                          <Fragment>({properties})</Fragment>
                        ) : null}
                      </span>
                      <span>
                        {i.mapping && (
                          <Icon
                            type="check-circle"
                            style={{ color: "green", marginRight: 10 }}
                          />
                        )}
                      </span>
                    </Row>
                  }
                  key={i.product_id.toString()}
                  style={customPanelStyle}
                >
                  {i.mapping ? (
                    <MappingDetails
                      mapping={i.mapping}
                      onRemoveMapping={onDelete.bind(null, id)}
                    />
                  ) : (
                    <div>
                      <h3>Assign Mapping</h3>
                      <Mapping
                        onSave={onSaveMapping}
                        product={i}
                        listing={listing}
                      />
                    </div>
                  )}
                </Panel>
              );
            })}
          </Collapse>
        </Col>
      </Row>
    </Styled.Container>
  );
};

class ListingDetailsView extends React.Component {
  componentDidMount() {
    const { currentStoreId, match } = this.props;
    this.props.dispatch(
      listingActions.getListingDetails(currentStoreId, match.params.id)
    );
  }

  componentWillUnmount() {
    this.props.dispatch(mappingActions.clearSearch());
  }

  onSaveMapping = payload => {
    if (payload.mappingId) {
      return this.props
        .dispatch(
          listingActions.saveMapping(
            payload.mappingId,
            payload.productId,
            payload
          )
        )
        .catch(err => {
          console.log(err);
          message.error(err.response.data.message);
        });
    } else {
      return this.props
        .dispatch(listingActions.createMapping(payload))
        .catch(err => {
          console.log(err);
          message.error(err.response.data.message);
        });
    }
  };

  onDelete = (id, mapping) => {
    return this.props.dispatch(listingActions.deleteMapping(mapping.id, id));
  };

  render() {
    const { currentStoreId, match, listingDetails } = this.props;
    return (
      <ListingDetails
        listing={listingDetails}
        listingId={match.params.id}
        currentStoreId={currentStoreId}
        onSaveMapping={this.onSaveMapping}
        onDelete={this.onDelete}
      />
    );
  }
}

export default connect((state, props) => ({
  ...state.session,
  listingDetails: state.listings.listingDetails[props.match.params.id]
}))(ListingDetailsView);
